import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * WindowMaxIcon ~
*/
export default function WindowMaxIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14H5v5h5V17H7Zm7-9V7h3v3h2V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.517,1.524H1.736V22.37H22.517Zm-2,18.845H3.736V3.524H20.517Z"
  })));
}